"use client";

import React from "react";
import { Accordion, AccordionItem } from "@heroui/accordion";
import { Icon } from "@iconify/react";

const Questions = () => {
  const frequentlyQuestions = [
    {
      question: "What is Cotton and how does it work?",
      answer:
        "Cotton is a platform that connects individuals and businesses with verified service providers across various industries for efficient, high-quality service delivery.",
    },
    {
      question: "What services can I find on Cotton?",
      answer:
        "You can access a broad range of services including professional, artisan, educational, technical, and corporate services through Cotton.",
    },
    {
      question:
        "What is the difference between Cotton for Individuals and Cotton for Enterprises?",
      answer:
        "Cotton for Individuals is tailored for personal service requests, while Cotton for Enterprises is a web platform built for managing complex service needs (e.g Procurements, Bid Management etc.) for organizations and businesses.",
    },
    {
      question: "What is Cotton as a Service?",
      answer:
        "Cotton as a Service allows public and private sector organizations to leverage our standards, expertise, and partner network to execute high-impact projects and build high-performance teams. Capacity development and technology transfer trainings are primarily what Cotton as a Service is about. The CSR arm of many organizations and government agencies across Africa often contract Cotton to deliver capacity development and technology transfer trainings through CaaS.",
    },
  ];

  return (
    <section>
      <div
        className="page-max-width flex flex-col items-center justify-center py-[32px] px-4 md:px-0"
        data-aos="fade-up"
      >
        <div className="text-green-600 text-xs font-medium leading-4 mb-[7px] text-center">
          100% Cotton
        </div>

        <div className="text-foreground text-[24px] leading-8 md:text-[32px] md:leading-10 font-medium tracking-[-0.16px] max-w-xs text-center">
          Frequently
          <br />
          asked questions
        </div>
      </div>

      <Accordion
        className="w-full max-w-2xl mx-auto px-4 md:px-0"
        data-aos="fade-up"
        data-aos-delay="100"
        hideIndicator={false}
        selectionMode="multiple"
        variant="splitted"
      >
        {frequentlyQuestions.map((item, index) => (
          <AccordionItem
            key={index}
            aria-label={item.question}
            className="mb-3 rounded-[32px] overflow-hidden bg-neutral-50"
            classNames={{
              base: "shadow-none border-none",
              trigger: "p-3 md:p-4 hover:bg-transparent data-[open=true]:pb-2",
              content:
                "pt-0 pb-4 px-4 md:px-5 text-sm md:text-base text-neutral-600",
            }}
            data-aos="fade-up"
            data-aos-delay={index * 100}
            indicator={({ isOpen }) => (
              <Icon
                className={`text-neutral-500 transition-transform duration-300 ${
                  isOpen ? "rotate-45" : ""
                }`}
                icon="lucide:plus"
                width={20}
              />
            )}
            title={
              <div className="flex items-center gap-3">
                <span className="text-xs font-medium leading-4 shrink-0 w-8 h-8 text-neutral-500 rounded-full flex items-center justify-center bg-white">
                  {index + 1}
                </span>

                <span className="text-neutral-950 text-xs md:text-base font-medium text-left">
                  {item.question}
                </span>
              </div>
            }
          >
            {item.answer}
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default Questions;
